import { memo } from 'react'

const HomeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.33 3.415A.75.75 0 0 1 6 3h12a.75.75 0 0 1 .67.415l2.25 4.5a.75.75 0 0 1 .08.335v3a.75.75 0 0 1-.75.75h-.75v8.25a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V12h-.75a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 .08-.335l2.25-4.5ZM6 12v7.5h12V12H6Zm13.5-1.5V8.427L17.537 4.5H6.463L4.5 8.427V10.5h3V9H9v1.5h2.25V9h1.5v1.5H15V9h1.5v1.5h3ZM11.25 15h-1.5v-1.5h1.5V15Zm3 0h-1.5v-1.5h1.5V15Zm-3 2.25h-1.5v-1.5h1.5v1.5Zm3 0h-1.5v-1.5h1.5v1.5Z"
      clipRule="evenodd"
    />
  </svg>
)

export default memo(HomeIcon)
